
const accordionItem = document.querySelectorAll('.accordion-list .accordion');

accordionItem.forEach((item) => {
    const listener = item.querySelector('.title-block');
    listener?.addEventListener('click', () => {
        const accDisplay = item.querySelector('.accordion-display');
        const accIcons = item.querySelectorAll('.accordion-icon');
        accDisplay?.classList.toggle('expand');
        accIcons.forEach((icon) => {
            icon.classList.toggle('active');
        })
    });
});